<template>
  <div class="about">
    <h1 @click="getParams">This is an about page</h1>
  </div>
</template>


<script>
// @ is an alias to /src


export default {
  name: 'About',
  methods: {
    getParams () {
       console.log('Params: ', this.$route.params);
    }
  },
}
</script>